import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import {RadioButton} from 'primereact/radiobutton';
import {Dropdown} from 'primereact/dropdown';
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import NumberFormat from 'react-number-format';
import LinearProgress from "@material-ui/core/LinearProgress";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const EditContractView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-8">
                        <TitlePage title="Administración \ Contrato Bilateral OTC \ Editar Contrato"/>
                    </div>
                    <div className="p-col-4" align="right">
                        <Button label="Cancelar" className="p-button-secondary"
                                onClick={props.returnContractOTCPage}/>&nbsp;
                        <Button label="Guardar" onClick={props.saveChanges}/>
                    </div>
                    <div className="p-col-12"> <Divider/> </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Institución" isBold={true}/>
                        <SubtitleLabel header={props.dataContract.nomCorto}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Opera OTC" isBold={true}/>
                        <RadioButton inputId="rb1" name="otc" value="1"
                                     checked={props.otc === '1'}
                                     onChange={props.saveRadioButtonOption}/>
                        <label htmlFor="rb2" className="p-radiobutton-label">Sí</label>
                        &nbsp;&nbsp;
                        <RadioButton inputId="rb1" name="otc" value="0"
                                     checked={props.otc === '0'}
                                     onChange={props.saveRadioButtonOption}/>
                        <label htmlFor="rb2" className="p-radiobutton-label">No</label>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Aforo OTC" isBold={true}/>
                        <NumberFormat decimalScale={2}
                                      id={3}
                                      required={true}
                                      fixedDecimalScale={true}
                                      name="aforoOtcPorCien"
                                      placeholder="Ex: 999.00"
                                      value={props.dataContract.aforoOtcPorCien}
                                      onChange={props.handleChangeValue}
                                      customInput={InputText}
                                      disabled={props.disabledFields}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">&nbsp;</div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Cta. Receptora de Garantías" isBold={true}/>
                        <Dropdown placeholder="Seleccione..."
                                  name="cuenta"
                                  filter={true}
                                  filterBy="cuenta"
                                  optionLabel="cuenta"
                                  options={props.institutionAccounts}
                                  value={props.cuentaObject}
                                  onChange={props.handleChangeValue}
                                  disabled={props.disabledFields}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Nivel de Confianza" isBold={true}/>
                        <Dropdown placeholder="Seleccione..."
                                  name="descrAforo"
                                  filter={true}
                                  required={true}
                                  filterBy="detailAforo"
                                  optionLabel="detailAforo"
                                  options={props.aforos}
                                  value={props.descrAforoObject}
                                  onChange={props.handleChangeValue}
                                  disabled={props.disabledFields}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Línea de crédito" isBold={true}/>
                        <NumberFormat thousandSeparator={true}
                                      id={11}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      name="lineaCredito"
                                      placeholder="Ex: 9,999.00"
                                      value={props.dataContract.lineaCredito}
                                      onChange={props.handleChangeValue}
                                      customInput={InputText}
                                      isNumericString={true}
                                      disabled={props.disabledFields}/>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-lg-6">&nbsp;</div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(EditContractView);